// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PriceParity20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PriceParity20: FC<PriceParity20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M2 17v-1.5h7.25V6.375c-.32-.111-.6-.288-.844-.531A2.204 2.204 0 0 1 7.875 5H5l2.5 5.75c-.014.68-.299 1.226-.854 1.635A3.112 3.112 0 0 1 4.75 13c-.708 0-1.34-.205-1.896-.615-.555-.41-.84-.954-.854-1.635L4.5 5H3V3.5h4.868c.157-.444.43-.806.817-1.083A2.198 2.198 0 0 1 9.998 2c.487 0 .926.139 1.315.417.388.277.662.636.82 1.076H17V5h-1.5l2.5 5.745c0 .684-.278 1.23-.833 1.64A3.129 3.129 0 0 1 15.26 13c-.715 0-1.35-.205-1.906-.615-.555-.41-.84-.954-.854-1.635L15 5h-2.875c-.111.32-.288.6-.531.844-.243.243-.525.42-.844.531V15.5H18V17H2Zm11.583-6.25h3.334L15.25 6.937l-1.667 3.813Zm-10.5 0h3.334L4.75 6.937 3.083 10.75ZM9.996 5c.21 0 .39-.071.535-.214a.714.714 0 0 0 .219-.532.736.736 0 0 0-.214-.535.714.714 0 0 0-.532-.219.736.736 0 0 0-.535.214.714.714 0 0 0-.219.532c0 .21.071.39.214.535.143.146.32.219.532.219Z" />
        </svg>
    );
};

export default PriceParity20;
